module.exports = __webpack_public_path__ + "static/media/securex_logo.15a091c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/integrations_logos/securex_logo.png
// module id = 303
// module chunks = 0